export enum BAATypeEnum {
    C2Keep,
    NonC2Keep
}